import React, { useState, useEffect, useRef } from 'react';
import MapPanel from "../basic/MapPanel";
import MapLegend from '../specific/MapLegend';
import Slider from '@mui/material/Slider';
import Button from '@mui/material/Button';
import { BlurCircular } from '@mui/icons-material';
import {
    buildColoredMapPathsPerWork,
    buildOperacaoStatusGateFromData,
    createMapValueLegends,
    getHistCoordsPoint,
    parseMapNumericValue,
} from '../../usecases/mapPathUtils';

const getCoordsItems = (workData) => workData?.[3]?.histCoords || [];

const buildRelevoPaths = (data, legends) =>
    buildColoredMapPathsPerWork({
        data,
        getItems: getCoordsItems,
        getShouldIncludeItem: (workData) => buildOperacaoStatusGateFromData(workData),
        legends,
        getValue: (item) => item.alt,
        getCoords: getHistCoordsPoint,
    });

const Map_relevo = ({ data, implementWidthMeters }) => {
    const [legends, setLegends] = useState([]);
    const [path, setPath] = useState([]);
    const [marker, setMarker] = useState([]);
    const [centerMap, setCenterMap] = useState(null);
    const [loadingMap, setLoadingMap] = useState(true);
    const [sliderValue, setSliderValue] = useState([0, 100]);
    const [realMin, setRealMin] = useState(0);
    const [realMax, setRealMax] = useState(100);
    const isInitialLoadRef = useRef(true);

    const createLegends = (newMin, newMax) => {
        const newLegends = createMapValueLegends(newMin, newMax);
        setLegends(newLegends);
        return newLegends;
    };
    
    
    const handleSliderChange = (event, newValue) => {
        setSliderValue(newValue);
    };

    const applyLimits = () => {
        const [newMin, newMax] = sliderValue;
        createLegends(newMin, newMax);
    };  

    const processPath = () => {
        const currentHistory = data[3]?.histCoords || [];
        if (!currentHistory || currentHistory.length === 0) {
            return;
        }

        if (!legends || legends.length === 0) {
            return;
        }
        
        setPath(buildRelevoPaths(data, legends));
    };

    const handleLegendChange = (legendId) => {
        const legendsCopy = legends.map((legend) =>
            legend.id === legendId ? { ...legend, show: !legend.show } : legend
        );
        setLegends(legendsCopy);
    };

      useEffect(() => {
        isInitialLoadRef.current = true;
        const currentHistory = data[3]?.histCoords || [];
        
        if (currentHistory && currentHistory.length > 0) {
            const min = currentHistory.reduce((acc, item) => {
                const alt = parseMapNumericValue(item.alt);
                return alt != null && alt > 0 && alt < acc ? alt : acc;
            }, Number.MAX_VALUE);
            const max = currentHistory.reduce((acc, item) => {
                const alt = parseMapNumericValue(item.alt) || 0;
                return alt > acc ? alt : acc;
            }, 0);

            const newRealMin = min !== Number.MAX_VALUE ? min : 0;
            const newRealMax = max;

            setRealMin(newRealMin);
            setRealMax(newRealMax);
            setSliderValue([newRealMin, newRealMax]);
            
            const newLegends = createLegends(newRealMin, newRealMax);
            isInitialLoadRef.current = false;

            setPath(buildRelevoPaths(data, newLegends));
            setLoadingMap(false);
    
            setMarker([
                { latitude: currentHistory[0].lat, longitude: currentHistory[0].lng, coordinateType: 'first' },
                { latitude: currentHistory[currentHistory.length - 1].lat, longitude: currentHistory[currentHistory.length - 1].lng, coordinateType: 'last' }
            ]);
            setCenterMap({ lat: currentHistory[0].lat, lng: currentHistory[0].lng });
        } else {
            setPath([]);
            setLoadingMap(false);
        }
    }, [data]);

    // Reprocessa caminho sempre que as legendas mudarem (após carregamento inicial)
    useEffect(() => {
        if (isInitialLoadRef.current) {
            return;
        }
        if (legends && legends.length > 0) {
            processPath();
        }
    }, [legends]);
    


    return (
        <div style={{width: '100%', alignItems:'center'}}>
            <h3>Variação de altitude do relevo durante o trabalho</h3>
            {loadingMap ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '600px' }}>
                    <div className="spinner"></div>
                    <BlurCircular style={{ fontSize: '40px', marginLeft: '20px' }} />
                </div>
            ) : (
                <>
                    <MapPanel markers={marker} zoomMap={17} centerMap={centerMap} linhas={path} height={600} implementWidthMeters={implementWidthMeters} />
                    <MapLegend legends={legends} onLegendChange={handleLegendChange} />
                    <div className="no-print" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '20px 0' }}>
                        <Slider
                            style={{ width: '60%', marginRight: '20px', marginLeft: '24px' }}
                            value={sliderValue}
                            onChange={handleSliderChange}
                            valueLabelDisplay="auto"
                            min={realMin}
                            max={realMax}
                        />
                        <Button 
                            onClick={applyLimits} 
                            style={{ backgroundColor: '#ffca20', color: '#000', borderRadius: '5px' }}
                        >
                            Aplicar Limites
                        </Button>
                    </div>
                </>
            )}
        </div>
    );
};

export default Map_relevo;
